import { render, staticRenderFns } from "./ComputerPoster.vue?vue&type=template&id=10902668&scoped=true"
import script from "./ComputerPoster.vue?vue&type=script&lang=js"
export * from "./ComputerPoster.vue?vue&type=script&lang=js"
import style0 from "./ComputerPoster.vue?vue&type=style&index=0&id=10902668&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10902668",
  null
  
)

export default component.exports